export default __webpack_public_path__ + "files/Roadmap_South_Bohemia_Region.docx";